export const APPLY_INTENT_PARAM = 'apply';

/** Only used to parse relative paths; never appears in the URL this returns. */
const RELATIVE_BASE = 'http://relative.invalid';

/**
 * Builds the /login URL that brings the visitor back to `currentHref` with the
 * apply-confirmation modal already open, so the application they had started is
 * not lost across the login. Built with URL/searchParams (never string
 * concatenation): the offer URL can already carry an `apply` param, and two
 * `apply` keys make Next hand back an array, which `useEntryPointModal` would
 * not match — a silent failure.
 */
export const buildLoginUrlWithApplyIntent = (
  currentHref: string,
  prefill?: { email?: string; phoneNumber?: string }
): string => {
  const prefillQuery = prefill?.email
    ? `&email=${encodeURIComponent(prefill.email)}`
    : prefill?.phoneNumber
    ? `&phone_number=${encodeURIComponent(prefill.phoneNumber)}`
    : '';

  // `new URL('', base)` resolves to the base instead of throwing, so an empty
  // href has to be turned away here rather than in the catch below.
  if (!currentHref) return `/login${prefillQuery ? `?${prefillQuery.slice(1)}` : ''}`;

  let target: string;
  try {
    // A relative base so both an absolute `window.location.href` and a router
    // `asPath` ('/posizione/x?scout=Y') parse the same way. Only pathname and
    // search are read back, so the base never reaches the produced URL.
    const url = new URL(currentHref, RELATIVE_BASE);
    url.searchParams.set(APPLY_INTENT_PARAM, 'true');
    target = `${url.pathname}${url.search}`;
  } catch {
    // Not something we can parse: send the visitor to the bare login rather than throwing.
    return `/login${prefillQuery ? `?${prefillQuery.slice(1)}` : ''}`;
  }

  return `/login?redirect_url=${encodeURIComponent(target)}${prefillQuery}`;
};
